<div class="coworking-home-container">
  <div class="side-bar">
    <sidebar-home [userType]="'coworking'" [id]="coworkingId"></sidebar-home>
  </div>
  <div class="header">
    <header-home></header-home>
  </div>
  <div class="home">
    <div *ngIf="content === 'home'" class="empty-space">
      <img [src]="getConfirmation">
      <p>{{ 'coworking-profile.on-construction' | translate}}</p>
    </div>
    <cowing-core-spaces-home *ngIf="content === 'spaces'"></cowing-core-spaces-home>
    <cowing-core-bookings-home *ngIf="content === 'booking'"></cowing-core-bookings-home>
  </div>
  <div class="footer">
    <cowing-footer [type]="EFooterStyleInput.Secondary"></cowing-footer>
  </div>
</div>
